import React from "react";
import styles from "../../styles/results.module.css";

const FieldValue = ({text} : {text:string}) => {
  return <span className={styles.typography_secondary}>{text}</span>;
};

export default FieldValue;
